import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';

import { FuseProfileAboutComponent } from './about/about.component';
import { CuttingAppointManagerDialogComponent } from './about/cutting-appoint-manager-dialog/cutting-appoint-manager-dialog.component';
import { ChangeEmailComponent } from './change-email/change-email.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { IdentityDocumentComponent } from './identity-document/identity-document.component';
import { FuseProfileComponent } from './profile.component';
import { ProfileService } from './profile.service';

const routes = [
  {
    path: 'profile',
    component: FuseProfileComponent,
    resolve: {
      profile: ProfileService,
    },
  },
];

@NgModule({
  declarations: [
    FuseProfileComponent,
    FuseProfileAboutComponent,
    ChangePasswordComponent,
    ChangeEmailComponent,
    CuttingAppointManagerDialogComponent,
    IdentityDocumentComponent,
  ],
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatToolbarModule,
    MatPaginatorModule,
    CdkTableModule,
    MatTableModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatListModule,

    FuseSharedModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [ProfileService],
})
export class ProfileModule {}
